/**
 * Url to call api
 *
 * @type {string}
 */
const API_BASE_URI = process.env.VUE_APP_API_BASE_URI;
export const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;
export const apiBaseUrl = `${API_ENDPOINT}/${API_BASE_URI}`;
